import * as React from "react";
import { cva } from "class-variance-authority";
import { Slot } from "radix-ui";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center cursor-pointer justify-center gap-2 whitespace-nowrap rounded-md text-base transition-[color,box-shadow,border] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 outline-none focus-visible:border-neutral-500 focus-visible:ring-neutral-200 focus-visible:ring-[3px]",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:ring-4 hover:ring-neutral-200",
        destructive:
          "bg-red-100 text-red-700 shadow-xs hover:bg-red-200 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
        outline:
          "border hover:border-neutral-400 border-neutral-300 text-neutral-700 bg-background hover:bg-neutral-100",
        secondary: "bg-[#efeff0] text-neutral-700 shadow-xs hover:bg-[#e3e3e5]",
        gradient:
          "group animate-rainbow text-primary-foreground relative h-10 border-2 border-transparent bg-[length:200%] [background-clip:padding-box,border-box,border-box] [background-origin:border-box] transition-colors before:animate-rainbow before:absolute before:bottom-[-20%] before:left-0 before:z-0 before:h-[3px] before:w-full before:bg-[linear-gradient(90deg,#fc4f8a,#a1ff42,#5ea500,#191F33,#4a5565)] before:[filter:blur(calc(0.625*1rem))] bg-[linear-gradient(var(--primary),var(--primary)),linear-gradient(var(--primary)_30%,rgba(0,0,0,0)),linear-gradient(90deg,#fc4f8a,#a1ff42,#5ea500,#191F33,#4a5565)]",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "size-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Button({ className, variant, size, asChild = false, ...props }) {
  const Comp = asChild ? Slot.Root : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button, buttonVariants };
